import { render, staticRenderFns } from "./MainScript.vue?vue&type=template&id=4f06e6dc&"
import script from "./MainScript.vue?vue&type=script&lang=js&"
export * from "./MainScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports